/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/Dropdown.module.css';
import arrowIcon from '../../assets/profile/Vector (13).png';

export interface SearchableMultiSelectDropdownProps {
	placeholder?: string;
	options: string[];
	selected: string[];
	onChange: (values: string[]) => void;
	width?: string;
	height?: string | number;
	menuMaxHeight?: string | number;
}

const SearchableMultiSelectDropdown: React.FC<
	SearchableMultiSelectDropdownProps
> = ({
	placeholder = 'Select',
	options,
	selected,
	onChange,
	width = '100%',
	height = '58px',
	menuMaxHeight = '240px',
}) => {
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (ref.current && !ref.current.contains(e.target as Node)) {
				setOpen(false);
				setSearch('');
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const toggleOption = (value: string) => {
		if (selected.includes(value)) {
			onChange(selected.filter(v => v !== value));
		} else {
			onChange([...selected, value]);
		}
	};

	const displayText = selected.length > 0 ? selected.join(', ') : placeholder;

	const norm = (v: string | number) => (typeof v === 'number' ? `${v}px` : v);

	// 🔥 FILTER LOGIC
	const filteredOptions = options.filter(opt =>
		opt.toLowerCase().includes(search.toLowerCase())
	);

	return (
		<div
			className={styles.wrapper}
			style={{ width: norm(width) }}
			ref={ref}
		>
			<div
				className={`${styles.dropdown} ${open ? styles.active : ''}`}
				onClick={() => setOpen(!open)}
				style={{ height: norm(height) }}
			>
				<span className={styles.text}>{displayText}</span>
				<img
					src={arrowIcon}
					className={`${styles.icon} ${open ? styles.rotate : ''}`}
					alt="toggle"
				/>
			</div>

			{open && (
				<div
					className={styles.menu}
					style={{ maxHeight: norm(menuMaxHeight) }}
				>
					{/* 🔍 SEARCH INPUT */}
					<input
						className={styles.search}
						placeholder="Search..."
						value={search}
						onChange={e => setSearch(e.target.value)}
						autoFocus
					/>

					{/* OPTIONS */}
					{filteredOptions.map((opt, i) => (
						<label key={i} className={styles.menuItem}>
							<span>{opt}</span>
							<input
								type="checkbox"
								checked={selected.includes(opt)}
								onChange={() => toggleOption(opt)}
							/>
						</label>
					))}

					{/* NO RESULT */}
					{filteredOptions.length === 0 && (
						<div className={styles.noResult}>No results found</div>
					)}
				</div>
			)}
		</div>
	);
};

export default SearchableMultiSelectDropdown;
